<div class="zodiac_card_mainwrap">
  <div class="grey_gradientborder">
    <div
      class="zodiac_card_innerwrap"
      [style.background-image]="'url(' + card.imageUrl + ')'"
    >
      <div class="zodiac_card_locked" *ngIf="card.locked">
        <div class="zodiac_card_lock_img">
          <img
            src="../../../assets/images/mystery-dashboard-images/mystery_zodiaccard_lockimg.webp"
            alt=""
          />
        </div>
      </div>
      <span class="zodiac_card_availability" [class.locked]="card.locked">{{ card.locked ? ('Unlocks on ' + card.unlockDate) : 'Available Now' }}</span>
      <div class="zodiac_card_contentwrap">
        <h1 class="zodiac_card_title">
          {{ card.name }}
        </h1>
        <div class="zodiac_card_content">
          <div class="zodiac_card_content_datesignwrap">
            <p class="zodiac_card_content_date">{{ card.dateRange }}</p>
            <div class="zodiac_card_content_sign">
              <img [src]="card.signUrl" alt="" />
            </div>
          </div>
          <div class="card_border_img"></div>
          <p class="zodiac_card_content_desc">
            {{ card.description }}
          </p>
          <div class="mysteryschool_commonbutton_wrapper mystery_button_wing">
            <button class="mysteryschool_commonbutton">Learn More</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
